/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_InsertInputs */

const en_wc_tut_ui_insert = /** @type {(inputs: Wc_Tut_Ui_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert: tables, pictures, shapes, links, headers and footers, fields, symbols.`)
};

/**
* | output |
* | --- |
* | "Insert: tables, pictures, shapes, links, headers and footers, fields, symbols." |
*
* @param {Wc_Tut_Ui_InsertInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_insert = /** @type {((inputs?: Wc_Tut_Ui_InsertInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_InsertInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_insert(inputs)
});
export { wc_tut_ui_insert as "wc.tut.ui.insert" }